import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AdminLayout from '../../layouts/admin/AdminLayout';
import LogListPage from '../../pages/admin/LogListPage/LogListPage';
import CityListPage from '../../pages/admin/CityListPage/CityListPage';
import CustomerListPage from '../../pages/admin/CustomerListPage/CustomerListPage';
import PersonPage from '../../pages/admin/PersonPage/PersonPage';
import OrderListPage from '../../pages/admin/OrderListPage/OrderListPage';
import MailMessageListPage from '../../pages/admin/MailMessageListPage/MailMessageListPage';
import OrderPage from '../../pages/admin/OrderPage/OrderPage';
import DashboardPage from '../../pages/admin/DashboardPage/DashboardPage';
import UseTermsPage from '../../pages/common/UseTermsPage/UseTermsPage';
import SupportPage from '../../pages/common/SupportPage/SupportPage';
import SettingsPage from '../../pages/admin/SettingsPage/SettingsPage';
import LogPage from '../../pages/admin/LogPage/LogPage';
import LogIntegrationListPage from '../../pages/admin/LogIntegrationListPage/LogIntegrationListPage';
import LoggerIntegrationPage from '../../pages/admin/LogIntegrationPage/LogIntegrationPage';

const AdminRoutes = () => (
  <AdminLayout>
    <Routes>
      <Route path="/" element={<DashboardPage />} />
      <Route path="/usuarios" element={<CustomerListPage />} />
      <Route path="/emails" element={<MailMessageListPage />} />
      <Route path="/usuarios/:code" element={<PersonPage />} />
      <Route path="/pedidos" element={<OrderListPage />} />
      <Route path="/pedidos/:code" element={<OrderPage />} />
      <Route path="/cidades" element={<CityListPage />} />
      <Route path="/logs" element={<LogListPage />} />
      <Route path="/logs/:code" element={<LogPage />} />
      <Route path="/logs-integration" element={<LogIntegrationListPage />} />
      <Route path="/logs-integration/:code" element={<LoggerIntegrationPage />} />
      <Route path="/terms" element={<UseTermsPage />} />
      <Route path="/support" element={<SupportPage />} />
      <Route path="/configuracoes" element={<SettingsPage />} />
      <Route path="/*" element={<DashboardPage />} />
      </Routes>
  </AdminLayout>
);

export default AdminRoutes;
